"use client";

import { useState } from "react";
import Image from "next/image";
import Badges from "../Blog/components/Badges";
const styles = new Proxy({"PostContent":"PostContent-21ca0","aligncenter":"aligncenter-21ca0","alignleft":"alignleft-21ca0","alignright":"alignright-21ca0","Post":"Post-21ca0","Sidebar":"Sidebar-21ca0","SidebarTitle":"SidebarTitle-21ca0","TagsWrapper":"TagsWrapper-21ca0","TagsContainer":"TagsContainer-21ca0","TagsClosed":"TagsClosed-21ca0","TagsToggle":"TagsToggle-21ca0","SidebarTag":"SidebarTag-21ca0","LatestPosts":"LatestPosts-21ca0","BackLink":"BackLink-21ca0","BackArrow":"BackArrow-21ca0","PostTitle":"PostTitle-21ca0","AuthorInfo":"AuthorInfo-21ca0","AuthorLeft":"AuthorLeft-21ca0","AuthorAvatar":"AuthorAvatar-21ca0","AuthorName":"AuthorName-21ca0","PostDate":"PostDate-21ca0","FeaturedImage":"FeaturedImage-21ca0","FormBox":"FormBox-21ca0"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import searchbarArrowDown from "@/themes/kinerva-v2/blog/searchbar-arrow-down.png";

const SidebarTags = ({ tags }: { tags: any[] }) => {
  const [toggle, setToggle] = useState(false);

  const tagClassName = [styles.TagsContainer, !toggle && styles.TagsClosed].filter(Boolean).join(" ");

  return (
    <div className={styles.TagsWrapper}>
      <div className={tagClassName}>
        <Badges badges={tags} limit={10} />
        <button
          type="button"
          className={styles.TagsToggle}
          onClick={() => setToggle((t) => !t)}
        >
          <Image
            src={searchbarArrowDown}
            alt="Toggle tags"
            width={46}
            height={32}
            style={{
              transform: toggle ? "rotate(180deg)" : "none",
              transition: "transform 0.2s",
            }}
          />
        </button>
      </div>
    </div>
  );
};

export default SidebarTags;
